module.exports = __webpack_public_path__ + "static/media/mobile.00aea07c.svg";